import _ from 'lodash'

let { isNumber, isString, isObject, isArray, isNaN, isDate, isEmpty, isBoolean, cloneDeep, isMap, isSet, isn } = _
//  cloneDeep是递归深拷贝
export { _, isNumber, isString, isObject, isArray, isNaN, isDate, isEmpty, isBoolean, cloneDeep, isMap, isSet, isn }
export * from 'lodash'
export * from './changeType'
export * from './random'
export * from './url'
export * from './form'
export * from './dom'

export {

}
